import { Injectable } from '@angular/core';
declare var THREE: any;
import { StageService } from './stage.service';
import { SizeHelperService } from './size-helper.service';
import { ConstantsService } from './constants.service';
import { BuildingCheckerService } from './building-checker.service';
import { ModelLoaderService } from './model-loader.service';
import { SetMaterialsService } from './set-materials.service';
import { LoadingSpinnerService } from './loading-spinner.service';
import { DataForDisplayingMenuItemsService } from './data-for-displaying-menu-items.service';

@Injectable()
export class StairLandingRightService{

  private supportPost: any;
  private intermediateStair: any;
  private bottomStair: any;
  private landing: any;
  private stairsPositions: any = [];
  private angle: any;
  private norm: any;
  firstOutPoint: any;
  secondOutPoint: any;

  constructor(
    private stage: StageService,
    private sizeHelper: SizeHelperService,
    private constants: ConstantsService,
    private buildingCheckerService: BuildingCheckerService,
    private modelLoaderService: ModelLoaderService,
    private setMaterialsService: SetMaterialsService,
    private loadingSpinnerService: LoadingSpinnerService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService
  ) { }

  build(config): Promise<any> {
    let intermediateStepPromise = this.modelLoaderService.loadLocalModel('Intermediate_step');
    let landingPromise = this.modelLoaderService.loadLocalModel('Landing');
    let supportPostPromise = this.modelLoaderService.loadLocalModel('Deck-Support');
    let bottomStepPromise = this.modelLoaderService.loadLocalModel('open_staircase_bottom');
    let promises = [intermediateStepPromise, bottomStepPromise, landingPromise, supportPostPromise];
    this.loadingSpinnerService.spinnerLoadingListAdd('StairLandingRightService');
    if(config.oldstair){
      this.stage.remove(config.oldstair)
    }
    return Promise.all(promises)
      .then(res => {
        this.loadingSpinnerService.spinnerLoadingListRemove('StairLandingRightService');
        this.intermediateStair = res[0];
        this.bottomStair = res[1];
        this.landing = res[2];
        res[3].children[0].material.map = new THREE.TextureLoader().load('../../assets/images/deck_fascia.png');
        let texture = new THREE.TextureLoader().load('../../assets/images/deck_fascia.png');
        let material = new THREE.MeshPhongMaterial({ map: texture });
        res[3].children[0].material = material;
        res[3].children[0].castShadow = true;
        this.supportPost = res[3];
        if (config.superstructureId) {
          let A = config.firstPoint;
          let B = config.secondPoint;
          let AB = new THREE.Vector3(B.x - A.x, 0, B.y - A.y);
          // so stair don't built outside edge
          if (config.distance > AB.length() - config.width / 2 - this.constants.minimalSpaceForStairsOnSIde) {
            config.distance = AB.length() - config.width / 2 - this.constants.minimalSpaceForStairsOnSIde;
          }
          // remove stair if not enought space on edge
          if (config.width + this.constants.minimalSpaceForStairsOnSIde * 2 > AB.length()) {
            config.firstPoint.superstructureType = null;
            config.firstPoint.distance = null;
            config.firstPoint.superstructureId = null;
            config.firstPoint.floorId = null;
            return;
          }
        }
        this.setPositionsForStairs(config);
        const stairs = this.addStairs(config);
        this.setMaterialsService.setMaterialForStairs();
        return stairs;
      });
  }

  setPositionsForStairs(config) {

    let height = config.height;

    let A = config.firstPoint;
    let B = config.secondPoint;
    let rot: any = false;
    if (A.x >= B.x - 0.05 && A.x <= B.x + 0.05 && A.y > B.y) {
      rot = Math.PI * 3 / 2;
    }

    let AB = new THREE.Vector3(B.x - A.x, 0, B.y - A.y);
    let norm = new THREE.Vector3(AB.z, 0, -AB.x);

    let norm2 = norm.clone();
    let stairHeight = this.sizeHelper.INCHToCM(7);

    let down = new THREE.Vector3(0, -stairHeight, 0);
    let countIntermediateStairs = Math.floor(height / stairHeight);

    this.stairsPositions = [];
    let firstPosition = new THREE.Vector3(A.x, height, A.y);
    AB.setLength(config.distance);
    firstPosition.add(AB);

    for (let i = 0; i <= Math.floor(countIntermediateStairs / 2) + 1; i++) {
      this.stairsPositions[i] = new THREE.Vector3(firstPosition.x, height, firstPosition.z);

      norm.setLength(this.sizeHelper.INCHToCM(9));
      norm2.setLength(norm.length() / 2);
      this.stairsPositions[i].add(norm2);
      if (i !== countIntermediateStairs) {
        this.stairsPositions[i].add(down);

      }
      for (let j = 0; j < i; j++) {
        this.stairsPositions[i].add(norm);
        this.stairsPositions[i].add(down);
      }
    }

    norm.setLength(53.34 - 14);
    let downLanding = down.clone().setLength(1);
    this.stairsPositions[Math.floor(countIntermediateStairs / 2)].add(norm);
    this.stairsPositions[Math.floor(countIntermediateStairs / 2)].add(downLanding);

    norm.set(norm.z, 0, -norm.x);
    downLanding.setLength(stairHeight - 3);

    for (let i = Math.floor(countIntermediateStairs / 2) + 1; i < countIntermediateStairs; i++) {
      norm.setLength(53.34 + 14);
      this.stairsPositions[i] = this.stairsPositions[Math.floor(countIntermediateStairs / 2)].clone();
      this.stairsPositions[i].add(norm);
      this.stairsPositions[i].add(downLanding);

      norm.setLength(this.sizeHelper.INCHToCM(9));
      for (let j = 0; j < i - (Math.floor(countIntermediateStairs / 2) + 1); j++) {
        this.stairsPositions[i].add(norm);
        this.stairsPositions[i].add(down);
      }
    }


    var med = new THREE.Vector3(B.x - A.x, 0, B.y - A.y);
    med.setLength(1);
    this.norm = med;

    if (rot) {
      this.norm.rot = rot;
    }



    var nullVec = new THREE.Vector3(-1, 0, 0);
    this.angle = med.angleTo(nullVec);

    if (med.x * nullVec.x + med.z * nullVec.z <= 0 && med.x * nullVec.z - med.z * nullVec.x < 0) {
      this.angle += Math.PI;
    }

    this.firstOutPoint = this.stairsPositions[countIntermediateStairs - 1].clone();
    this.secondOutPoint = this.stairsPositions[Math.floor(countIntermediateStairs / 2)].clone();
    norm2.setLength(config.width / 2);
    this.firstOutPoint.add(norm2);
    this.secondOutPoint.add(norm2);
    let halfStairLengthVector = new THREE.Vector3(norm2.z, 0, -norm2.x);
    halfStairLengthVector.setLength(this.sizeHelper.INCHToCM(9) / 2);
    this.firstOutPoint.add(halfStairLengthVector);
    halfStairLengthVector.setLength(config.width / 2);
    halfStairLengthVector.negate();
    this.secondOutPoint.add(halfStairLengthVector);
    this.firstOutPoint.y = 0;
    this.secondOutPoint.y = 0;
  }

  addStairs(config) {
    let stairs = new THREE.Object3D();
    stairs.userData.firstOutPoint = this.firstOutPoint;
    stairs.userData.secondOutPoint = this.secondOutPoint;
    const superstructureId = stairs.id;
    stairs.userData.type = "LandingRight";
    // stairs.position.set(this.stairsPositions[0].x, this.stairsPositions[0].y, this.stairsPositions[0].z);
    stairs.name = 'stairs';
    stairs.userData.name = 'stairs';
    this.stage.add(stairs);

    stairs.userData.config = config;
    stairs.userData.config.superstructureType = 'stairLandingRight';
    stairs.userData.config.superstructureId = superstructureId;

    config.firstPoint.distance = config.distance;
    config.firstPoint.superstructureType = 'stairLandingRight';
    config.firstPoint.superstructureId = superstructureId;
    config.firstPoint.width = config.width;
    config.firstPoint.stairs = true;
    config.firstPoint.superstructure = stairs;

    for (let i = 0; i < this.stairsPositions.length - 1; i++) {
      if (i == Math.floor(this.stairsPositions.length / 2)) {
        this.norm.set(-this.norm.z, 0, this.norm.x);
      } else {
        let obj = this.intermediateStair.clone();
        obj.userData.isDeckComponent = true;
        obj.userData.isChildStep = true;
        obj.position.set(this.stairsPositions[i].x, this.stairsPositions[i].y - 34.867 / 2, this.stairsPositions[i].z);;
        obj.rotation.y = this.angle;

        let dir = obj.getWorldDirection(new THREE.Vector3());

        for (let j = 0; j < 4; j++) {
          let x = this.norm.x * dir.z - this.norm.z * dir.x;
          if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
            obj.rotation.y += Math.PI / 2;
            dir = obj.getWorldDirection(new THREE.Vector3());
          }
        }

        let x = this.norm.x * dir.z - this.norm.z * dir.x;
        if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
          obj.rotation.y = - obj.rotation.y;
          dir = obj.getWorldDirection(new THREE.Vector3());
        }

        for (let j = 0; j < 6; j++) {
          let x = this.norm.x * dir.z - this.norm.z * dir.x;
          if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
            obj.rotation.y += Math.PI / 2;
            dir = obj.getWorldDirection(new THREE.Vector3());
          }
        }

        obj.rotation.y -= Math.PI / 2;
        // if (this.norm.rot) {
        //   obj.rotation.y = this.norm.rot;
        // }
        if (i > Math.floor(this.stairsPositions.length / 2)) {
          obj.rotation.y += Math.PI;
        }


        if (i == Math.floor((this.stairsPositions.length / 2) - 1)) {
          obj.name = "Bottom";
        }

        if (i == 0) {
          obj.name = "Top";
        }

        if (i == Math.floor((this.stairsPositions.length / 2) + 1)) {
          obj.name = "RightTop";
        }


        this.stage.add(obj);

        THREE.SceneUtils.attach(obj, this.stage.getScene(), stairs);
      }
    }

    let i = Math.floor(this.stairsPositions.length / 2);//this.stairsPositions.length - 1;
    let obj = this.landing.clone();
    obj.userData.isDeckComponent = true;
    obj.userData.isChildStep = true;
    obj.position.set(this.stairsPositions[i].x, this.stairsPositions[i].y - 17.16 / 2, this.stairsPositions[i].z);;
    obj.rotation.y = this.angle;

    let dir = obj.getWorldDirection(new THREE.Vector3());

    for (let j = 0; j < 4; j++) {
      let x = this.norm.x * dir.z - this.norm.z * dir.x;
      if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
        obj.rotation.y += Math.PI / 2;
        dir = obj.getWorldDirection(new THREE.Vector3());
      }
    }

    let x = this.norm.x * dir.z - this.norm.z * dir.x;
    if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
      obj.rotation.y = - obj.rotation.y;
      dir = obj.getWorldDirection(new THREE.Vector3());
    }

    for (let j = 0; j < 6; j++) {
      let x = this.norm.x * dir.z - this.norm.z * dir.x;
      if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
        obj.rotation.y += Math.PI / 2;
        dir = obj.getWorldDirection(new THREE.Vector3());
      }
    }

    obj.rotation.y -= Math.PI / 2;
    // if (this.norm.rot) {
    //   obj.rotation.y = this.norm.rot;
    // }

    obj.name = "Landing";

    this.stage.add(obj);
    THREE.SceneUtils.attach(obj, this.stage.getScene(), stairs);

    let supportPosts: any = [];
    for (let j = 0; j < 4; j++) {
      supportPosts[j] = this.supportPost.clone();
      supportPosts[j].userData.isDeckComponent = true;
      supportPosts[j].userData.isChildStep = true;
      supportPosts[j].position.set(obj.position.x, obj.position.y, obj.position.z);
      supportPosts[j].position.y -= (17.78 + 2.54) / 2;
      supportPosts[j].position.y /= 2;
      supportPosts[j].rotation.set(obj.rotation.x, obj.rotation.y, obj.rotation.z);
      supportPosts[j].scale.y = (supportPosts[j].position.y * 2) / this.constants.supportPostSize.height;
      this.stage.add(supportPosts[j]);
      THREE.SceneUtils.attach(supportPosts[j], this.stage.getScene(), stairs);

    }
    let shift = this.norm.clone();
    shift.setLength(this.constants.inermediateStepSize.width / 2 - (this.sizeHelper.INCHToCM(2.5) + +this.constants.supportPostSize.width));
    supportPosts[0].position.add(shift);
    supportPosts[1].position.add(shift);
    shift.negate();
    supportPosts[2].position.add(shift);
    supportPosts[3].position.add(shift);
    shift = new THREE.Vector3(shift.z, 0, -shift.x);
    supportPosts[0].position.add(shift);
    supportPosts[2].position.add(shift);
    shift.negate();
    supportPosts[1].position.add(shift);
    supportPosts[3].position.add(shift);



    // let obj = this.bottomStair.clone();
    // obj.position.set(this.stairsPositions[this.stairsPositions.length - 1].x, this.stairsPositions[this.stairsPositions.length - 1].y, this.stairsPositions[this.stairsPositions.length - 1].z);;
    // obj.rotation.y = this.angle;
    // this.stage.add(obj);

    i = this.stairsPositions.length - 1;
    obj = this.bottomStair.clone();
    obj.userData.isDeckComponent = true;
    obj.userData.isChildStep = true;
    obj.position.set(this.stairsPositions[i].x, this.stairsPositions[i].y - 17.16 / 2, this.stairsPositions[i].z);;
    obj.rotation.y = this.angle;

    dir = obj.getWorldDirection(new THREE.Vector3());

    for (let j = 0; j < 4; j++) {
      let x = this.norm.x * dir.z - this.norm.z * dir.x;
      if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
        obj.rotation.y += Math.PI / 2;
        dir = obj.getWorldDirection(new THREE.Vector3());
      }
    }

    x = this.norm.x * dir.z - this.norm.z * dir.x;
    if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
      obj.rotation.y = - obj.rotation.y;
      dir = obj.getWorldDirection(new THREE.Vector3());
    }

    for (let j = 0; j < 6; j++) {
      let x = this.norm.x * dir.z - this.norm.z * dir.x;
      if (!(this.norm.z > -dir.z - 0.05 && this.norm.z < -dir.z + 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
        obj.rotation.y += Math.PI / 2;
        dir = obj.getWorldDirection(new THREE.Vector3());
      }
    }

    obj.rotation.y -= Math.PI / 2;
    // if (this.norm.rot) {
    //   obj.rotation.y = this.norm.rot;
    // }
    obj.rotation.y += Math.PI;


    obj.name = "RightBottom";

    this.stage.add(obj);
    THREE.SceneUtils.attach(obj, this.stage.getScene(), stairs);
    let floor = this.stage.getFloorById(config.floorId);
    if (!config.prevPoint) {
      const points = floor.userData.points;
      for (let i = 0; i < points.length; i++) {
        if (config.firstPoint === points[i]) {
          config.prevPoint = i > 0 ? points[i - 1] : points[points.length - 1];
          config.nextPoint = (i < points.length - 2) ? points[i + 2] : ((i === points.length - 2) ? points[0] : points[1]);
        }
      }
    }
    THREE.SceneUtils.attach(stairs, this.stage.getScene(), floor);
    return stairs;
  }

  rescaleStairs(): void {
    let stairs = this.stage.getStairs().filter(obj =>
      obj.userData.config.superstructureType === 'stairLandingRight');
    for (let i = 0; i < stairs.length; i++) {

      if (this.buildingCheckerService.checkHeightForStairs('stairLandingRight', stairs[i].parent.getWorldPosition(new THREE.Vector3()).y)) {
        stairs[i].userData.config.height = stairs[i].parent.getWorldPosition(new THREE.Vector3()).y;
        stairs[i].parent.remove(stairs[i]);
        this.build(stairs[i].userData.config);
      }
      else {
        this.dataForDisplayingMenuItemsService.needStairRemove.next(stairs[i]);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/stair-landing-right.service.ts